import Typography from "@material-ui/core/Typography"
import Alert from "@material-ui/lab/Alert"
import { useTranslations } from "./use-translations"
import { useAppContext } from "../../../app-context/use-app-context"
import AccountDeletionConfirmationDialog from "./AccountDeletionConfirmationDialog"
import { UserViewModel } from "../../api/user"
import { useStyles } from "./styles"

const AccountDeletionCard = ({ user }: { user: UserViewModel }) => {
  const translations = useTranslations()
  const { appContext } = useAppContext()
  const classes = useStyles()
  const shouldShowOrganisationTransferInfo = appContext.mainContextList?.length > 1

  return (
    <>
      <Typography variant="h6">{translations.deleteAccountHeader}</Typography>
      {shouldShowOrganisationTransferInfo && (
        <div style={{ marginTop: 12 }}>
          <Alert severity="error" className={classes.alert}>
            {translations.deleteAccountInfoText}
          </Alert>
        </div>
      )}

      <div style={{ marginTop: 24 }}>
        <Typography variant="body1">{translations.deleteAccountDescription}</Typography>
        <AccountDeletionConfirmationDialog user={user} />
      </div>
    </>
  )
}

export default AccountDeletionCard
